// extracted by mini-css-extract-plugin
module.exports = {"userImageContainer":"user-image-container_userImageContainer__lvbqx","inHeader":"user-image-container_inHeader__7ZlZ6","inProfile":"user-image-container_inProfile__LJDTA"};